module.exports = __webpack_public_path__ + "media/printed-materials/03-educator-college-qrg-4da253c7.jpg";